// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"386":"14cd97f6","456":"bb4bf7f3","715":"37e9c717","724":"262075d6"}[chunkId] + ".chunk.js";
};